const BASE = "/financeiro/substituicao-regional";

export const REGIONAL_SUBSTITUTION_ROUTES = {
  LIST: BASE,
  CREATE: `${BASE}/criar`,
  editById: (id: string): string => `${BASE}/editar/${id}`,
} as const;
